import React from 'react'
import { connect } from 'react-redux'
import { Modal, Header, Button, List, Accordion, Icon, Segment, Divider, Label } from 'semantic-ui-react'
import copy from 'copy-to-clipboard'

class ErrorMsgPopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = { opened: false }
  }
  componentWillReceiveProps() {
    this.setState({ opened: true })
  }
  handleClick = (e) => {
    this.state.detailsOpened ?
      this.setState({detailsOpened: false}) : this.setState({detailsOpened: true})
  }
  handleClose = () => {
    this.setState({opened: false, detailsOpened: false})
  }
  copyToClipboard = (requestId) => {
    copy(requestId)
  }
  getErrorMessage = () => {
    const networkError = this.props.errors.networkError
    const graphQLErrors = this.props.errors.graphQLErrors
    if(networkError) {
      const requestId = networkError.result && networkError.result.requestId
      const header = 'Network Error'
      const message = (
        <div>
          {requestId ?
            <div>
              <b>Status : </b>
              {networkError.statusCode}
              <br/>
              <b>Request ID: </b>
              <Label>
                <Icon name='save' corner onClick={() => this.copyToClipboard(requestId)} />
                {requestId}
              </Label>
              <br/>
              <b>Message: </b>
              <div>
                {networkError.result.message ? networkError.result.message :
                  JSON.stringify(networkError.result.error)}
              </div>
            </div>
          :
            <div>
              <b>Message: </b>
              <div>
                {networkError.message}
            </div>
        </div>
    }
        </div>
      )
      return {header: header, message: message}
    }
    if(graphQLErrors) {
      const header = graphQLErrors.length > 1 ? 'GraphQL Errors' : 'GraphQL Error'
      const message = graphQLErrors.length > 1 ? (
        <List animated size='large'>
          {graphQLErrors.map(
            (error, index) => <List.Item key={`Error ${index}`}>{error.message}</List.Item>
          )}
          </List>
        ) : (
        <List size='large'>
          <List.Item><b>Message: </b>{graphQLErrors[0].message}</List.Item>
          </List>
      )
      return {header: header, message: message}
    }
    }
  getErrorDetails = () => {
    const operations = this.props.errors.operation
    return (
      <Segment>
        {operations.length > 1 ? 'Operations' : 'Operation'}
        <Divider fitted />
        <List animated>
          {operations.map((operation, index) =>  {
            return (
              <List.Item key={`Operation ${index}`}>{operation.operationName}</List.Item>
            )
          })}
        </List>
      </Segment>
    )
  }

  render = () => {
    const errors = this.props.errors
    //if(errors.networkError) console.log(errors.networkError.statusCode)
    if(errors.networkError || errors.graphQLErrors) {
      const errorMessage = this.getErrorMessage()
      const details = this.getErrorDetails()
      // This error is handled in specific component
      if (
        errors.networkError &&
        errors.networkError.result &&
        (errors.networkError.result.message === "Created document type exist" ||
          /Invalid documents: \[[0-9]+.*\]/.test(
            errors.networkError.result.message
          ))
      )
        return null;
      return (
        this.renderModal(errors, errorMessage, details)
      )
    } else return null
  }

  renderModal = (errors, errorMessage, details) => {
    return(
      <Modal
        open={this.state.opened}
        size='tiny'
        dimmer={false}
      >
        <Header size='large' color='grey' dividing icon='warning sign' content={errorMessage.header} />
        <Modal.Content>
          {errorMessage.message}
          <Accordion>
            <Accordion.Title active={this.state.detailsOpened} onClick={this.handleClick}>
              <Icon name='dropdown'/>
              Details
            </Accordion.Title>
            <Accordion.Content active={this.state.detailsOpened}>
              {details}
            </Accordion.Content>
          </Accordion>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color='red' onClick={this.handleClose}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    errors: state.errors
  }
}

ErrorMsgPopup = connect(mapStateToProps)(ErrorMsgPopup)

export default ErrorMsgPopup



// WEBPACK FOOTER //
// ./src/component/ErrorMsgPopup.js